module.exports = __webpack_public_path__ + "img/lista_invitados.5717ee6a.png";